/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type JobEventAccepted_event$ref = any;
type JobEventAssigned_event$ref = any;
type JobEventBuildStepUploadCreated_event$ref = any;
type JobEventCancelation_event$ref = any;
type JobEventCanceled_event$ref = any;
type JobEventChanged_event$ref = any;
type JobEventCreated_job$ref = any;
type JobEventFinished_event$ref = any;
type JobEventLimited_event$ref = any;
type JobEventRetried_event$ref = any;
type JobEventScheduled_event$ref = any;
type JobEventStarted_event$ref = any;
type JobEventTimedOut_event$ref = any;
export type JobEventType = "ACCEPTED" | "ASSIGNED" | "BUILD_STEP_UPLOAD_CREATED" | "CANCELATION" | "CANCELED" | "CHANGED" | "FINISHED" | "LIMITED" | "NOTIFICATION" | "RETRIED" | "SCHEDULED" | "STARTED" | "TIMED_OUT" | "UNBLOCKED" | "%future added value";
export type JobStates = "ACCEPTED" | "ASSIGNED" | "BLOCKED" | "BLOCKED_FAILED" | "BROKEN" | "CANCELED" | "CANCELING" | "FINISHED" | "LIMITED" | "LIMITING" | "PENDING" | "RUNNING" | "SCHEDULED" | "SKIPPED" | "TIMED_OUT" | "TIMING_OUT" | "UNBLOCKED" | "UNBLOCKED_FAILED" | "WAITING" | "WAITING_FAILED" | "%future added value";
import type { FragmentReference } from "relay-runtime";
declare export opaque type JobActivityTimelineList_job$ref: FragmentReference;
export type JobActivityTimelineList_job = {|
  +uuid?: string,
  +state?: JobStates,
  +createdAt?: ?any,
  +events?: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +uuid: string,
        +timestamp: any,
        +type: JobEventType,
        +$fragmentRefs: JobEventLimited_event$ref & JobEventFinished_event$ref & JobEventRetried_event$ref & JobEventScheduled_event$ref & JobEventAssigned_event$ref & JobEventCanceled_event$ref & JobEventCancelation_event$ref & JobEventAccepted_event$ref & JobEventStarted_event$ref & JobEventTimedOut_event$ref & JobEventChanged_event$ref & JobEventBuildStepUploadCreated_event$ref,
      |}
    |}>
  |},
  +$fragmentRefs: JobEventCreated_job$ref,
  +$refType: JobActivityTimelineList_job$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "uuid",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "JobActivityTimelineList_job",
  "type": "Job",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "InlineFragment",
      "type": "JobTypeCommand",
      "selections": [
        v0,
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "state",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "createdAt",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "FragmentSpread",
          "name": "JobEventCreated_job",
          "args": null
        },
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "events",
          "storageKey": "events(first:30)",
          "args": [
            {
              "kind": "Literal",
              "name": "first",
              "value": 30,
              "type": "Int"
            }
          ],
          "concreteType": "JobEventConnection",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "edges",
              "storageKey": null,
              "args": null,
              "concreteType": "JobEventEdge",
              "plural": true,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "node",
                  "storageKey": null,
                  "args": null,
                  "concreteType": null,
                  "plural": false,
                  "selections": [
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventAssigned_event",
                      "args": null
                    },
                    v0,
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "type",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventLimited_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventFinished_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventRetried_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventScheduled_event",
                      "args": null
                    },
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "timestamp",
                      "args": null,
                      "storageKey": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventCanceled_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventCancelation_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventAccepted_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventStarted_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventTimedOut_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventChanged_event",
                      "args": null
                    },
                    {
                      "kind": "FragmentSpread",
                      "name": "JobEventBuildStepUploadCreated_event",
                      "args": null
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'af78bda168125149f40544cfa26cd3c5';
module.exports = node;
